import { useTranslation } from "react-i18next";

export enum RouteName {
    home = "home",
    spartan = "spartan",
    book = "book",


    usuarios = "usuarios",
    usuariosCrear = "usuariosCrear",
    usuariosActualizar = "usuariosActualizar",
    usuariosEliminar = "usuariosEliminar",

    profileCrear = "profileCrear",
    profile = "profile",

    notification = "notification",
    configuration = "configuration",

    sponsor = "sponsor",
    sponsorAdd = "sponsorAdd",
    sponsorDetail = "sponsorDetail",

    banner = "banner",
    bannerAdd = "bannerAdd",
    bannerDetail = "bannerDetail",

    program = "program",
    programAdd = "programAdd",
    programDetail = "programDetail",

    blog = "blog",
    blogAdd = "blogAdd",
    blogDetail = "blogDetail",
}

export const BASE_ROUTE = "/dashboard";

// Adaptación de las rutas para ser compatibles con claves de localización
export const useLocalizedRoutes = () => {
    const { t } = useTranslation(); // Obtenemos la función de traducción

    // Creamos un objeto ROUTE_NAME usando las traducciones
    const ROUTE_NAME: { [key in RouteName]: string } = {
        home: t('routes.home'),
        spartan: "/spartan",
        book: "/book",
        usuarios: t('routes.usuarios'),
        usuariosCrear: t('routes.usuariosCrear'),
        usuariosActualizar: t('routes.usuariosActualizar'),
        usuariosEliminar: t('routes.usuariosEliminar'),

        profileCrear: t('routes.profileCrear'),
        profile: t('routes.profile'),

        notification: t('routes.notification'),
        configuration: t('routes.configuration'),

        sponsor: t('routes.sponsor'),
        sponsorAdd: t('routes.sponsorAdd'),
        sponsorDetail: t('routes.sponsorDetail'),

        banner: t('routes.banner'),
        bannerAdd: t('routes.bannerAdd'),
        bannerDetail: t('routes.bannerDetail'),

        program: t('routes.program'),
        programAdd: t('routes.programAdd'),
        programDetail: t('routes.programDetail'),

        blog: t('routes.blog'),
        blogAdd: t('routes.blogAdd'),
        blogDetail: t('routes.blogDetail'),


    };

    // Devolvemos el objeto de rutas localizadas
    return ROUTE_NAME;
};



// export const ROUTE_NAME: { [key in RouteName]: string } = {

//     login: "/login",
//     home: "/home",
//     usuarios: "/company/:id/users",
//     usuariosCrear: "/users/create",
//     usuariosActualizar: "/users/update",
//     usuariosEliminar: "/users/delete",
//     bannedUsers: "/banned-users",
//     notification: "/notifications",
//     profileCrear: "/profile/new",
//     profile: "/profile/:id/detail",
//     configuration: "/configuration",
//     calendar: "/calendar",
//     configurationCalendar: "/calendar-configuration",
//     bussinessHours: "/business-hours",
//     workerBussinessHours: "/business-hours/user/:id",
//     companySetup: "/company-registration",
//     company: "/company/:id",
//     establishment: "/company/:id/establishments",
//     establishmentAdd: "/company/:idCompany/establishment",
//     establishmentDetail: "/company/:idCompany/establishment/:idEstablishment",
//     chats: "/company/:idCompany/chat"

// }


// export const ROUTE_NAME_ID = (
//     params: { [key: string]: any },
//     name: RouteName
// ): string => {
//     const routeTemplate = ROUTE_NAME[name];

//     if (!routeTemplate) {
//         console.error("La ruta no existe", name);
//         return "/dashboard/home";
//     }


//     let route = routeTemplate;

//     for (const [key, value] of Object.entries(params)) {
//         route = route?.replace(`:${key}`, encodeURIComponent(value?.toString()));
//     }

//     // Handle any missing parameters
//     if (route.includes(":")) {
//         console.error("Faltan parámetros en la ruta", route);
//         return "/dashboard/home";
//     }

//     return route;
// };

// Función para generar rutas dinámicas con parámetros, usando localización
export const ROUTE_NAME_ID = (
    params: { [key: string]: any },
    name: RouteName
): string => {
    const ROUTE_NAME = useLocalizedRoutes(); // Obtenemos las rutas traducidas
    const routeTemplate = ROUTE_NAME[name];

    if (!routeTemplate) {
        console.error("La ruta no existe", name);
        return "/dashboard/home";
    }

    let route = routeTemplate;

    // Reemplazo de los parámetros dinámicos en la ruta
    for (const [key, value] of Object.entries(params)) {
        route = route?.replace(`:${key}`, encodeURIComponent(value?.toString()));
    }

    // Manejo de parámetros faltantes en la ruta
    if (route.includes(":")) {
        console.error("Faltan parámetros en la ruta", route);
        return "/dashboard/home";
    }

    return route;
};

export const ROUTE_NAME_ID_2 = (

    params: { [key: string]: any },
    route_name: any,
    name: RouteName
): string => {

    const routeTemplate = route_name[name];

    // console.log("mira que es params", params);
    // console.log("mira que es route_name", route_name);
    // console.log("mira que es name", name);
    // console.log("mira que es routeTemplate", routeTemplate);


    if (!routeTemplate) {
        console.error("La ruta no existe", name);
        return "/dashboard/home";
    }


    let route = routeTemplate;

    for (const [key, value] of Object.entries(params)) {
        route = route?.replace(`:${key}`, encodeURIComponent(value?.toString()));
    }


    // Handle any missing parameters
    if (route.includes(":")) {
        console.error("Faltan parámetros en la ruta", route);
        return "/dashboard/home";
    }

    console.log("devuelvo esto", route)

    return route;
};
